import unAuthAxios from '../../../Utils/unAuthAxios';
import axios from '../../../Utils/axios';

const globals = require('../../../config/' +
  process.env.REACT_APP_STAGE +
  '/Portal/globals');

// GET param 변환
export function getURL(API, param) {
  let url = API;
  if (param !== undefined && param !== '') {
    for (let val in param) {
      if (
        !(
          param[val] === undefined ||
          param[val] === null ||
          String(param[val]) === ''
        )
      ) {
        if (url.indexOf('?') > -1) url += '&';
        else url += '?';
        url += val + '=' + param[val];
      }
    }
  }
  return url;
}

const findByAuthorization = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/user/session/${param.authorization}`,
    param
  );

  return axios.get(url).then((response) => {
    return response;
  });
};

/**
 * ID 중복여부 체크
 * @param {string} portalId
 */
const existId = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/exist/id`, param);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

/**
 * User TIN & Email 중복체크
 */
const existUserTinAndEmail = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/exist/tin/email`, param);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

/**
 * 회원가입
 */
const insertUser = (param, header) => {
  const url = getURL(`${globals.exApiUrl}/user/signUp`);

  const formData = new FormData();

  Object.keys(param.userDto).forEach((key) => {
    if (param.userDto[key]) {
      formData.append(`user.${key}`, param.userDto[key]);
    }
  });

  Object.keys(param.companyDto).forEach((key) => {
    if (param.companyDto[key]) {
      formData.append(`company.${key}`, param.companyDto[key]);
    }
  });

  return unAuthAxios.post(url, formData, '', header).then((response) => {
    return response;
  });
};

/**
 * 로그인
 */
const signIn = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/signIn`);

  return unAuthAxios.post(url, param).then((response) => {
    return response;
  });
};

/**
 * 로그아웃
 */
const signOut = () => {
  const url = getURL(`${globals.exApiUrl}/user/signOut`);

  return axios.post(url).then((response) => {
    return response;
  });
};

/**
 * ID 찾기
 */
const searchId = (param, header) => {
  const url = getURL(`${globals.exApiUrl}/user/search/id`);

  return unAuthAxios.post(url, param, '', header).then((response) => {
    return response;
  });
};

/**
 * ID찾기 메일 전송
 */
const sendMailSearchId = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/send/mail/search/id`, param);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

/**
 * 비밀번호 찾기
 */
const searchPw = (param, header) => {
  const url = getURL(`${globals.exApiUrl}/user/search/password`);

  return unAuthAxios.post(url, param, '', header).then((response) => {
    return response;
  });
};

/**
 * 비밀번호 찾기 메일 전송
 */
const sendSearchPwMail = (param) => {
  const url = getURL(
    `${globals.exApiUrl}/user/send/mail/search/password`,
    param
  );

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

/**
 * 비밀번호 변경
 */
const changePassword = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/change/password`);

  return axios.post(url, param).then((response) => {
    return response;
  });
};

/**
 * 비밀번호 초기화
 */
const resetPassword = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/reset/password`);

  return unAuthAxios.post(url, param).then((response) => {
    return response;
  });
};

/**
 * 유저 정보 조회
 */
const getUser = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/${param.userNo}`);

  return axios.get(url).then((response) => {
    return response;
  });
};

/**
 * 유저 정보 변경
 */
const updateUser = (param) => {
  const url = getURL(`${globals.exApiUrl}/user`);

  return axios.put(url, param).then((response) => {
    return response;
  });
};

/**
 * 현재 비밀번호 확인 (이전 비밀번호와의 일치여부 조회를 위해)
 */
const findByPortalIdAndPassword = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/find/portalId/password`);

  return axios.post(url, param).then((response) => {
    return response;
  });
};

const searchUserList = (param) => {
  const url = getURL(`${globals.exApiUrl}/user`, param);

  return unAuthAxios.get(url).then((response) => {
    return response;
  });
};

const changeUserStatus = (param) => {
  const url = getURL(`${globals.exApiUrl}/user/status`);

  return unAuthAxios.put(url, param).then((response) => {
    return response;
  });
};

export default {
  findByAuthorization,

  existId,
  insertUser,
  existUserTinAndEmail,

  signIn,
  signOut,

  searchId,
  sendMailSearchId,

  searchPw,
  sendSearchPwMail,

  changePassword,
  resetPassword,
  getUser,
  updateUser,
  findByPortalIdAndPassword,
  searchUserList,
  changeUserStatus,
};
